import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { dateFormatter, showFromToTime } from "../../../../utils/helpers";
import { Event, AccessTime, KeyboardArrowDown } from '@material-ui/icons';

import translation from '../../../../translations/MobileSelectButton'
const lang = localStorage.getItem("lang");

const MobileSelectButton = props => {
  const {
    title,
    onClick,
    pickup,
    delivery,
    selectedPickupDate,
    selectedDeliveryDate,
    selectedPickupTime,
    selectedDeliveryTime,
    submitting,
} = props;

  const selectedClassName = classNames({
    "mobile-select-time": true,
    "selected-block": true,
    "selected-pickup": !submitting && pickup,
    "selected-delivery": !submitting && delivery,
    "disabled": (submitting && delivery) || (delivery && selectedPickupDate.default)
  });

  const NotSelected = () => {
    const notSelectedClassName = classNames({
      "mobile-select-time": true,
      "disabled": (submitting && delivery) || (delivery && selectedPickupDate.default)
    });

    return (
      <div onClick={onClick} className={notSelectedClassName}>
        <div className="mobile-select-header">
          <div className="mobile-select-icon">
            {pickup ? <Event /> : <AccessTime />}
          </div>
          <div className="mobile-select-content">
            <span className="mobile-select-title">{title}</span>
            <span className="mobile-select-placeholder">{translation.selectDateAndTime[lang]}</span>
          </div>
          <div className="mobile-select-arrow">
            <KeyboardArrowDown />
          </div>
        </div>
      </div>
    );
  };

  const SelectedBlock = () => {
    let date, time;

    if (pickup) {
      date = selectedPickupDate.date;
      time = selectedPickupTime;
    } else if (delivery) {
      date = selectedDeliveryDate.date;
      time = selectedDeliveryTime;
    }

    return (
      <div onClick={!submitting ? onClick : () => {}} className={selectedClassName} id={pickup ? 'step-4-pickup-container' : 'step-4-delivery-container'}>
        <div className="mobile-select-header">
          <div className="mobile-select-icon">
            {pickup ? <Event /> : <AccessTime />}
          </div>
          <div className="mobile-select-content">
            <span className="mobile-select-title">{title}</span>
            <div className="selected-date-time">
              <span className="selected-date">{dateFormatter(date)}</span>
              <span className="selected-time">{showFromToTime(time)}</span>
            </div>
          </div>
          <div className="mobile-select-arrow">
            <KeyboardArrowDown />
          </div>
        </div>
      </div>
    );
  };

  if (pickup) {
    return !selectedPickupDate.default ? <SelectedBlock /> : <NotSelected />;
  }
  return !selectedDeliveryDate.default ? <SelectedBlock /> : <NotSelected />;
};

const mapStateToProps = ({
  selectedPickupDate,
  selectedDeliveryDate,
  selectedPickupTime,
  selectedDeliveryTime,
  submitting
}) => ({
  selectedPickupDate,
  selectedDeliveryDate,
  selectedPickupTime,
  selectedDeliveryTime,
  submitting
});

export default connect(mapStateToProps)(MobileSelectButton);
